import { ReactComponent as ObjectDetectionIcon } from "assets/svgs/inspections/ObjectDetection.svg";

export const ObjectDetectionShowIcons = {
    false: <ObjectDetectionIcon className="w-6" />,
    true: <ObjectDetectionIcon className="w-6" />,
};
export const DefaultShowObjectDetection = false;
